export const SUCCESS_REDIRECT_URL = "/dashboard";

export const STRIPE_PORTAL_ID = ""; // Optional ID of a portal configuration

// --- Plans WITHOUT viewer chat (existing) ---
export const STRIPE_MONTHLY_PRICE_ID = "price_1Q5IL6IwkAI8JQRmDHsa9HMq";
export const STRIPE_ANNUAL_PRICE_ID = "price_1Q5fzhIwkAI8JQRmsSz1p1VI";

// --- Plans WITH viewer chat (new tiers) ---
// Monthly + Chat ($15/mo): product prod_UiIV7juIZgSWk6
// Annual  + Chat ($120/yr): product prod_UiIVmakjPf76Lu
export const STRIPE_MONTHLY_CHAT_PRICE_ID = "price_1TiruiIwkAI8JQRmLqEl1cC8";
export const STRIPE_ANNUAL_CHAT_PRICE_ID = "price_1TiruGIwkAI8JQRm48w803pc";

// Single source of truth for which active price ids unlock viewer chat.
// Read by AuthContext (`chatEntitled`) and re-checked server-side before any
// chat write. Keep placeholder strings out of the entitled set so an unset
// price id can never accidentally grant chat.
export const CHAT_ENABLED_PRICE_IDS = [
  STRIPE_MONTHLY_CHAT_PRICE_ID,
  STRIPE_ANNUAL_CHAT_PRICE_ID,
].filter((id) => typeof id === "string" && !id.startsWith("REPLACE_WITH_"));

export function isChatEnabledPriceId(priceId) {
  return Boolean(priceId) && CHAT_ENABLED_PRICE_IDS.includes(priceId);
}
